/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignDailyBonus200Response,
  GachaModel,
  MissionRewardRequestModel,
  UserMissionItemModel,
  UserMissionItemsModel,
} from '../models/index';
import {
    AssignDailyBonus200ResponseFromJSON,
    AssignDailyBonus200ResponseToJSON,
    GachaModelFromJSON,
    GachaModelToJSON,
    MissionRewardRequestModelFromJSON,
    MissionRewardRequestModelToJSON,
    UserMissionItemModelFromJSON,
    UserMissionItemModelToJSON,
    UserMissionItemsModelFromJSON,
    UserMissionItemsModelToJSON,
} from '../models/index';

export interface AssignDailyBonusRequest {
    xComiciUserTokenRequired: string;
}

export interface CheckRewardRequest {
    xComiciUserTokenRequired: string;
    missionRewardRequestModel: MissionRewardRequestModel;
}

export interface GetGachaInfoRequest {
    xComiciUserTokenRequired: string;
}

export interface GetUserMissionsRequest {
    xComiciUserTokenRequired: string;
    isAchieved?: boolean;
    missionStatus?: number;
}

export interface PullGachaRequest {
    xComiciUserTokenRequired: string;
}

export interface RegisterMissionRequest {
    xComiciUserTokenRequired: string;
}

/**
 * 
 */
export class AchievementApi extends runtime.BaseAPI {

    /**
     * ログインした直後、このAPIを呼び出す。ユーザがログインする時、デイリーログインのボーナスを付与する
     * ログインボーナス付与
     */
    async assignDailyBonusRaw(requestParameters: AssignDailyBonusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignDailyBonus200Response>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling assignDailyBonus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/loginBounus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignDailyBonus200ResponseFromJSON(jsonValue));
    }

    /**
     * ログインした直後、このAPIを呼び出す。ユーザがログインする時、デイリーログインのボーナスを付与する
     * ログインボーナス付与
     */
    async assignDailyBonus(requestParameters: AssignDailyBonusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignDailyBonus200Response> {
        const response = await this.assignDailyBonusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * リクエストパラメータで指定された条件に応じたミッションの進捗状況を管理します。 達成されたミッションがある場合は、チケットの付与を行い、達成したミッションの情報を返却します。 現状はサイト間ミッションの進捗状況のみ管理しています。今後ミッションの種類が増えた場合はこのAPIに実装内容を更新して進捗を管理する予定です。
     * ミッション進捗管理
     */
    async checkRewardRaw(requestParameters: CheckRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMissionItemModel>>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling checkReward.');
        }

        if (requestParameters.missionRewardRequestModel === null || requestParameters.missionRewardRequestModel === undefined) {
            throw new runtime.RequiredError('missionRewardRequestModel','Required parameter requestParameters.missionRewardRequestModel was null or undefined when calling checkReward.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/missions/reward`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MissionRewardRequestModelToJSON(requestParameters.missionRewardRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMissionItemModelFromJSON));
    }

    /**
     * リクエストパラメータで指定された条件に応じたミッションの進捗状況を管理します。 達成されたミッションがある場合は、チケットの付与を行い、達成したミッションの情報を返却します。 現状はサイト間ミッションの進捗状況のみ管理しています。今後ミッションの種類が増えた場合はこのAPIに実装内容を更新して進捗を管理する予定です。
     * ミッション進捗管理
     */
    async checkReward(requestParameters: CheckRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMissionItemModel>> {
        const response = await this.checkRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ガチャのページに遷移する時、該当するユーザーのガチャ状態をチェックする
     * ガチャ状態取得
     */
    async getGachaInfoRaw(requestParameters: GetGachaInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GachaModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getGachaInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/gacha`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GachaModelFromJSON(jsonValue));
    }

    /**
     * ガチャのページに遷移する時、該当するユーザーのガチャ状態をチェックする
     * ガチャ状態取得
     */
    async getGachaInfo(requestParameters: GetGachaInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GachaModel> {
        const response = await this.getGachaInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されているミッション一覧を取得します。
     * ミッション一覧を取得する
     */
    async getUserMissionsRaw(requestParameters: GetUserMissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserMissionItemsModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getUserMissions.');
        }

        const queryParameters: any = {};

        if (requestParameters.isAchieved !== undefined) {
            queryParameters['isAchieved'] = requestParameters.isAchieved;
        }

        if (requestParameters.missionStatus !== undefined) {
            queryParameters['missionStatus'] = requestParameters.missionStatus;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/missions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserMissionItemsModelFromJSON(jsonValue));
    }

    /**
     * 配信されているミッション一覧を取得します。
     * ミッション一覧を取得する
     */
    async getUserMissions(requestParameters: GetUserMissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserMissionItemsModel> {
        const response = await this.getUserMissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 該当するユーザーがガチャを引く
     * ガチャを引く
     */
    async pullGachaRaw(requestParameters: PullGachaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GachaModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling pullGacha.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/gacha`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GachaModelFromJSON(jsonValue));
    }

    /**
     * 該当するユーザーがガチャを引く
     * ガチャを引く
     */
    async pullGacha(requestParameters: PullGachaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GachaModel> {
        const response = await this.pullGachaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 対象ユーザーに未登録のミッションがある場合、content_mission_usersテーブルに登録を行います。
     * ミッション登録
     */
    async registerMissionRaw(requestParameters: RegisterMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling registerMission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/missions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 対象ユーザーに未登録のミッションがある場合、content_mission_usersテーブルに登録を行います。
     * ミッション登録
     */
    async registerMission(requestParameters: RegisterMissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.registerMissionRaw(requestParameters, initOverrides);
    }

}
